// Add DOM4 support, https://github.com/WebReflection/dom4
import 'dom4';

// Add Babel polyfill for ES2015, https://babeljs.io/docs/usage/polyfill/
import 'babel-polyfill';

//
import FontFaceObserver from 'fontfaceobserver';

// Import all components from Audi UI library
import {
  Alert,
  Audioplayer,
  Breadcrumb,
  Checkbox,
  Dropdown,
  Flyout,
  Header,
  Modal,
  Nav,
  Notification,
  Pagination,
  Player,
  Popover,
  Progress,
  Radio,
  Response,
  Select,
  Slider,
  Indicator,
  Spinner,
  Textfield,
  Tooltip
} from '../../../src/index';

// Upgrade all Audi UI components
let alertComponents = Alert.upgradeElements();
let breadcrumbComponents = Breadcrumb.upgradeElements();
Audioplayer.upgradeElements();
Checkbox.upgradeElements();
Dropdown.upgradeElements();
Flyout.upgradeElements();
Header.upgradeElements();
Modal.upgradeElements();
let navComponents = Nav.upgradeElements();
Notification.upgradeElements();
let paginationComponents = Pagination.upgradeElements();
Player.upgradeElements();
Popover.upgradeElements();
let progressComponents = Progress.upgradeElements();
Radio.upgradeElements();
Response.upgradeElements();
Select.upgradeElements();
Slider.upgradeElements();
Indicator.upgradeElements();
let spinnerComponents = Spinner.upgradeElements();
Textfield.upgradeElements();
Tooltip.upgradeElements();

// ----------------------------------------------------------------------------
// Load SVG sprite with Audi Icons
// ----------------------------------------------------------------------------
Array.from(document.querySelectorAll('[data-svg-sprite]')).forEach(element => {
  const src = element.getAttribute('data-svg-sprite');
  if (typeof src === 'string' && src.length > 0) {
    let ajax = new XMLHttpRequest();
    ajax.open('GET', src, true);
    ajax.responseType = 'document';
    ajax.onload = function(event) {
      element.removeAttribute('data-src');
      try {
        element.appendChild(ajax.responseXML.documentElement);
      } catch (e) {
        console.log(e);
      }
    };
    ajax.send();
  }
});

// ----------------------------------------------------------------------------
// Modal effect:
// ----------------------------------------------------------------------------
Array.from(document.querySelectorAll('[data-toggle="modal"]')).forEach(element => {
  element.addEventListener('click', (event) => {
    let modal = Modal.getModalById(element.getAttribute('data-target'));
    if (modal) {
      modal.open(event.currentTarget);
    }
  });
});

Array.from(document.querySelectorAll('[data-dismiss="modal"]')).forEach(element => {
  element.addEventListener('click', (event) => {
    Modal.closeCurrentModal();
  });
});

// ----------------------------------------------------------------------------
// Update components after font 'Audi Type' was loaded:
// ----------------------------------------------------------------------------
let fontFaceObserverScreen = new FontFaceObserver('AudiTypeScreen');
fontFaceObserverScreen.load().then(function() {
  paginationComponents.forEach(component => {
    component.update();
  });
  breadcrumbComponents.forEach(component => {
    component.update();
  });
  alertComponents.forEach(component => {
    component.update();
  });
}, function() {
  // Error handling: Font is not available or timeout.
  console.warn('Warning: AudiTypeScreen not available.');
});

let fontFaceObserverExtended = new FontFaceObserver('AudiTypeExtended');
fontFaceObserverExtended.load().then(function() {
  navComponents.forEach(component => {
    component.update();
  });
}, function() {
  // Error handling: Font is not available or timeout.
  console.warn('Warning: AudiTypeExtended not available.');
});



/** WEBPACK FOOTER **
 ** D:/Node/audi-ui/~/eslint-loader!./audi/visual/js/audi.js
 **/